<!--
 * @Desc: 
 * @Author: wanglidong 王立冬
 * @Date: 2023-05-22 08:07:53
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-22 17:05:25
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
  <div class="login-container">
  </div>
</template>

<script>

export default {
  name: 'Login',
  components: {  },
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
